export const appSortIcon = {
    data: `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 5.5V7H8V5.5H3ZM3 9.25V10.75H12V9.25H3ZM3 13V14.5H17V13H3Z" fill="currentColor"/></svg>`,
    name: 'sort' as const
};